<template>
    <UiPagination
        :current-page="currentPage"
        :total-pages="totalPages"
        :prev-page="handlePrevPage"
        :next-page="handleNextPage"
        :go-to-page="handleGoToPage" />
</template>

<script setup lang="ts">
    const props = defineProps<{
        currentPage: number;
        totalPages: number;
        prevPage: () => void;
        nextPage: () => void;
        goToPage: (page: number) => void;
    }>();

    // Wrapper functions to scroll to top before navigation
    function handlePrevPage() {
        scrollToTop();
        props.prevPage();
    }

    function handleNextPage() {
        scrollToTop();
        props.nextPage();
    }

    function handleGoToPage(page: number) {
        scrollToTop();
        props.goToPage(page);
    }

    function scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
</script>

<style scoped>
    /* Styles are now provided by the UiPagination component */
</style>
